import React, {ReactElement, useMemo} from 'react';
import {Typography} from '@customink/pigment-react';
import {useAppSelector} from '../../hooks';
import ImageUploader from '../ImageUploader';
import ClearExistingImage from './ClearExistingImage';
import './index.scss';

const LogoForm: React.FC = (): ReactElement => {
  const storeDetails = useAppSelector(state => state.stores.storeDetails);
  const localImages = useAppSelector(state => state.stores.localImages);

  const imagePreview = useMemo(() => {
    const logoImageUrl = localImages.logo || storeDetails?.logoImageUrl;

    let title: string | undefined;
    if (localImages.logo) title = 'Image Preview:';
    else if (storeDetails?.logoImageUrl) title = 'Current Image:';

    return (
      !!logoImageUrl && (
        <div className="imagePreviewContainer">
          <Typography className="imagePreviewTitle" variant="captionLarge">
            {title}
          </Typography>
          <img
            className="imagePreview"
            src={logoImageUrl}
            alt={`logo ${title}`}
          />
        </div>
      )
    );
  }, [storeDetails, localImages]);

  return (
    <div className="logoForm">
      <Typography variant="captionLarge">
        Your logo will appear at the bottom of your store page and in emails to
        your customers. You can also set it to appear in your store banner.
      </Typography>
      <div className="imageUploader">
        <Typography variant="captionLarge" className="imageUploaderHeader">
          Upload Image
        </Typography>
        <ImageUploader storeImageType="logo" />
        <Typography variant="captionSmall">
          Accepted file types: .png and .jpeg. Max file size: 5MB. Recommended
          dimensions: 305 x 64px.
        </Typography>
        {imagePreview}
        <ClearExistingImage imageType="logo" />
      </div>
    </div>
  );
};

export default LogoForm;
